'use strict';
const Router = require('autor');

class Route extends Router.Route {
  load(resolve) {
    Router.post(document.location.origin + Router.location.pathname + '?partial', {}, (err, req) => {
      document.body.setAttribute('data-path', Router.location.pathname);
      document.querySelector('main').innerHTML = req.responseText;
      window.scrollTo( 0, 0 );
      resolve();
    });
  }

  bootstrap(route) {
    if (typeof route.title !== 'undefined') document.getElementById('overlay-title').innerHTML = route.title;
    else document.getElementById('overlay-title').innerHTML = '';
    // staticDot.placeRandomDot();
    if (typeof route.title !== 'undefined') document.title = 'All Conference — ' + route.title;
    else document.title = 'All Conference';

    this.scrollFunction = this.handleScroll.bind(this);
    this.onScroll();
  }


  onScroll() {
    document.addEventListener('scroll', this.scrollFunction);
  }

  handleScroll() {
    if (Router.route.path !== '/news') {
      document.removeEventListener('scroll', this.scrollFunction);
      return;
    }

    if (this.currentlyFetching === true) return;
    if (this.maxOffsetReached === true) return;
    var body = document.body,
        html = document.documentElement;
    var height = Math.max( body.scrollHeight, body.offsetHeight,
                           html.clientHeight, html.scrollHeight, html.offsetHeight );

    if (window.scrollY > height - window.innerHeight - window.innerHeight) {
      this.currentlyFetching = true;
      this.fetchNews();
    }
  }

  fetchNews() {
    let newsItems = document.querySelectorAll('.news__item');
    let offset = newsItems.length;

    var http = new XMLHttpRequest();
    var params = "offset=" + offset;
    http.open("POST", '/news', true);
    http.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
    http.onreadystatechange = () => { //Call a function when the state changes.
      if (http.readyState == 4 && http.status == 200) {
          if (Router.route.path !== '/news') return;

          this.currentlyFetching = false;
          if (http.responseText.trim() === '') {
            this.maxOffsetReached = true;
            return;
          }
          document.querySelector('.news').innerHTML = document.querySelector('.news').innerHTML + http.responseText;
      }
    }
    http.send(params);
  }

}

module.exports = Route;



// WEBPACK FOOTER //
// ./src/js/news.service.js